import React from 'react'

export const UserPreferencesHeading:React.FC<{heading: string}> = ({heading}) => {
  return (
    <div className="text-left text-primary font-semibold text-lg px-[12px] ">
      {heading}
    </div>
  )
}
